import { JWMLink } from "@components/JWMLink";
import PrivacyPolicyNotification from "@jmc/core/src/components/PrivacyPolicyNotification/PrivacyPolicyNotification";
import { useJnjBranding } from "@jmc/utils/hooks/useJnjBranding";
import { load as loadPrivacyPolicyUpdate } from "@redux/modules/privacyPolicyUpdate";
import { graphql, useStaticQuery } from "gatsby";
import React from "react";

import style from "./style.module.scss";

const ShowPrivacyPolicyUpdate = (props: undefined): JSX.Element => {
    const { allContentstackLegalDocuments } = useStaticQuery(graphql`
        query {
            allContentstackLegalDocuments {
                nodes {
                    onetrust_privacy_policy_id
                    publish_details {
                        locale
                    }
                }
            }
        }
    `);

    return (
        <PrivacyPolicyNotification
            currentPage={props.currentPage}
            LinkComponent={JWMLink}
            linkUrl="/privacy-policy"
            linkProps={{ external: false, fullWidth: false }}
            wrapperClassName={style.containerS}
            loadPrivacyPolicyUpdate={loadPrivacyPolicyUpdate}
            selectPrivacyPolicyData={(state) => state.privacyPolicy.data}
            useJnjBrandingHook={useJnjBranding}
            allContentstackLegalDocuments={allContentstackLegalDocuments}
        />
    );
};

export default ShowPrivacyPolicyUpdate;
